import { createReducer } from '@reduxjs/toolkit';

import {
  userSettingsError,
  userSettingsRequest,
  userSettingsStore,
  userSettingsStoreEntitlements,
  userSettingUpdateApiKey,
  userSettingUpdateCurrency,
} from './userSettingsActions.js';

const initialState = {
  requesting: false,
  error: null,
  isPlanPro: false,
  planId: 0,
  dueDate: null,
  accountId: 0,
  siteLimit: 1,
  mainCurrency: '$',
  apiKey: '',
  limits: {},
  usage: {},
};

const user = createReducer(initialState, (builder) => {
  builder
    .addCase(userSettingsRequest, (state) => ({ ...state, requesting: true, error: null }))
    .addCase(userSettingsError, (state, { payload }) => ({ ...state, error: payload, requesting: false }))
    .addCase(userSettingsStore, (state, { payload }) => {
      const { isPlanPro, dueDate, userId: accountId, siteLimit: siteLimit, planId, apiKey } = payload;

      return {
        ...state,
        isPlanPro: isPlanPro,
        planId,
        // isPlanPro: false,
        // planId: 1,

        dueDate,
        accountId,
        siteLimit,
        apiKey,
        error: null,
        requesting: false,
      };
    })
    .addCase(userSettingsStoreEntitlements, (state, { payload }) => ({ ...state, limits: payload.limits || {}, usage: payload.usage || {} }))
    .addCase(userSettingUpdateCurrency, (state, { payload: mainCurrency }) => ({ ...state, mainCurrency }))
    .addCase(userSettingUpdateApiKey, (state, { payload: apiKey }) => ({ ...state, apiKey }));
});

export default user;
